import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "@app/services";
import {NavController} from "@ionic/angular/standalone";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private auth: AuthService = inject(AuthService);
  private navController: NavController = inject(NavController);

  constructor() {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.isAuthenticated() || this.auth.checkAccessToken().then((result) => {
      if (result) {
        return true;
      }

      console.log('[AuthGuard] User is not authenticated, redirecting to login page');
      this.navController.navigateRoot('/user/login');
      return false;
    });
  }

}
